import { NavigationTab } from 'shared/model';

import { AddOwnerButtonLink } from './buttons';

export const TABS: Array<NavigationTab> = [
  {
    key: 'owners',
    path: '',
    label: 'Список владельцев',
    buttons: [
      {
        element: <AddOwnerButtonLink />,
        controller: 'Owner',
        right: 'Write',
      },
    ],
  },
];
